import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { ToggleButtonGroupDesignSystemScope } from '@openx/components-core/lib/ToggleButtonGroupField/ToggleButtonGroupDesignSystemScope.tsx';
import { InfoIcon } from '@phosphor-icons/react/Info';
import { useTranslation } from 'react-i18next';
export type CuratedPckgMode = 'template' | 'targeting';

type CuratedPackageModeSwitchProps = {
  mode: CuratedPckgMode;
  onModeChange: (mode: CuratedPckgMode) => void;
};

export const CuratedPackageModeSwitch = ({ mode, onModeChange }: CuratedPackageModeSwitchProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Stack direction="column" spacing={1} sx={theme => ({ justifyItems: 'center', marginBottom: theme.spacing(1) })}>
      <ToggleButtonGroupDesignSystemScope>
        <ToggleButtonGroup value={mode} exclusive onChange={(_, value) => onModeChange(value)}>
          <ToggleButton id="use-as-template" value="template">
            {t('Use as template')}
          </ToggleButton>

          <ToggleButton id="use-shared-targeting" value="targeting">
            {t('Use shared targeting')}
          </ToggleButton>
        </ToggleButtonGroup>
      </ToggleButtonGroupDesignSystemScope>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography
          variant="body1Bold"
          sx={theme => ({
            color: theme.palette.text.secondary,
            fontSize: '13px',
            textTransform: 'uppercase',
          })}
        >
          {t('Of the following:')}
        </Typography>

        <Tooltip
          title={t(
            "'Use As Template' to customize targeting for this deal only.\n'Use Shared Targeting' allows consistent settings across all deals using this package"
          )}
        >
          <IconButton size="small" aria-label="info-icon">
            <InfoIcon color={theme.palette.text.secondary} />
          </IconButton>
        </Tooltip>
      </Box>
    </Stack>
  );
};
